export const HEALTH_SUMMARY_RETRIEVE_REQUESTED = 'HEALTH_SUMMARY_RETRIEVE_REQUESTED';
export const HEALTH_SUMMARY_RETRIEVE_SUCCEED = 'HEALTH_SUMMARY_RETRIEVE_SUCCEED';
export const HEALTH_SUMMARY_RETRIEVE_FAILED = 'HEALTH_SUMMARY_RETRIEVE_FAILED';

export const HEALTH_SUMMARY_CREATE_REQUESTED = 'HEALTH_SUMMARY_CREATE_REQUESTED';
export const HEALTH_SUMMARY_CREATE_SUCCEED = 'HEALTH_SUMMARY_CREATE_SUCCEED';
export const HEALTH_SUMMARY_CREATE_FAILED = 'HEALTH_SUMMARY_CREATE_FAILED';

export const HEALTH_SUMMARY_UPDATE_REQUESTED = 'HEALTH_SUMMARY_UPDATE_REQUESTED';
export const HEALTH_SUMMARY_UPDATE_SUCCEED = 'HEALTH_SUMMARY_UPDATE_SUCCEED';
export const HEALTH_SUMMARY_UPDATE_FAILED = 'HEALTH_SUMMARY_UPDATE_FAILED';

export const HEALTH_SUMMARY_CONFIG_GET_REQUESTED = 'HEALTH_SUMMARY_CONFIG_GET_REQUESTED';
export const HEALTH_SUMMARY_CONFIG_GET_SUCCEED = 'HEALTH_SUMMARY_CONFIG_GET_SUCCEED';
export const HEALTH_SUMMARY_CONFIG_GET_FAILED = 'HEALTH_SUMMARY_CONFIG_GET_FAILED';

export const HEALTH_SUMMARY_RESET = 'HEALTH_SUMMARY_RESET';
